
// document.addEventListener('DOMContentLoaded', function() {
//     var buttons = document.querySelectorAll('button.checkout_buy_now');

//           setTimeout(function() {
//     buttons.forEach(function(button) {
//         button.addEventListener('click', function() {

//            if (window.location.href === 'https://devshopsimplenursing.myshopify.com/cart') { 
//                 window.location.href = '/checkout';
//             } else{ 
//                 window.location.href = '/checkout';
//             }
            
//             // var variantId = this.id; // Get variant ID from the button's id attribute
//             // var quantity = 1; // Set the quantity to add

//             // Gather line item properties from hidden input fields
//             // var properties = {};
//             // var inputs = document.querySelectorAll('.product-metafields input');
//             // inputs.forEach(function(input) {
//             //     properties[input.name] = input.value;
//             // });

//             // Prepare the data to post to the Shopify cart
//             // var formData = {
//             //     'items': [{
//             //         'id': variantId,
//             //         'quantity': quantity,
//             //          // 'properties':properties  
//             //     }]
//             // };

//             // Fetch API to add item to cart
//             // fetch('/cart/add.js', {
//             //     method: 'POST',
//             //     headers: {
//             //         'Content-Type': 'application/json',
//             //     },
//             //     body: JSON.stringify(formData)
//             // })
//             // .then(response => response.json())
//             // .then(data => {
//             //     console.log('Item added to cart', data);
//             //     // Redirect to checkout page 
//             //     window.location.href = '/checkout';
                  
//             // })
//             // .catch((error) => {
//             //     console.error('Error adding item to cart:', error);
//             // });
//         });
//     });
//              }, 100);
// });


document.addEventListener('DOMContentLoaded', function() {
    const buyNowButtons = document.querySelectorAll('.checkout_buy_now');

    buyNowButtons.forEach(button => {
        button.addEventListener('click', function() {
            let variantId = this.getAttribute('data-variant-id');
            let quantity = 1; // Change this if you want to allow modifying quantity

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: quantity
                    }]
                })
            })
            .then(response => response.json())
            .then(cart => {
                window.location.href = '/checkout';
            })
            .catch(error => console.error('Error adding item to cart:', error));
        });
    });
});
